export default function (state) {
    return state.items.filter(i => {
        return i.main;
    })[0];
}